'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function shuffle(arr) {
    var result = arr.slice();
    for(var i = result.length - 1; i >= 1; i--){
        var j = Math.floor(Math.random() * (i + 1));
        var ref;
        ref = [
            result[j],
            result[i]
        ], result[i] = ref[0], result[j] = ref[1], ref;
    }
    return result;
}
exports.shuffle = shuffle;
